import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';

export const ReassignContactsModal = ({
  open,
  onClose,
  onConfirm,
  agents,
  currentAgentId,
  loading = false,
}) => {
  const [selectedAgentId, setSelectedAgentId] = useState('');

  useEffect(() => {
    if (!open) {
      setSelectedAgentId('');
    }
  }, [open]);

  const options = (agents || []).filter((a) => a?._id && a._id !== currentAgentId);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h3" sx={{ py: 2 }}>Reasigna los contactos</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          No es posible eliminar este agente porque tiene contactos asignados. Reasigna sus contactos
          a otro agente para continuar con la eliminación.
        </Typography>

        <FormControl fullWidth size="small">
          <InputLabel id="reassign-agent-label">Agente destino</InputLabel>
          <Select
            labelId="reassign-agent-label"
            label="Agente destino"
            value={selectedAgentId}
            onChange={(e) => setSelectedAgentId(e.target.value)}
            disabled={loading}
            sx={{
              borderRadius: 2,
            }}
          >
            {options.map((item) => (
              <MenuItem key={item._id} value={item._id}>
                {item.display_name || item.email || item._id}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>Cerrar</Button>
        <Box sx={{ flex: 1 }} />
        <Button
          onClick={() => onConfirm?.(selectedAgentId)}
          variant="contained"
          disabled={!selectedAgentId || loading}
        >
          {loading ? 'Procesando...' : 'Asignar y eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ReassignContactsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  agents: PropTypes.array,
  currentAgentId: PropTypes.string,
  loading: PropTypes.bool,
};
